import { motion } from "framer-motion";
import { reveal } from "@/lib/motion";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <motion.footer {...reveal(0, 14)} data-testid="footer">
      <a className="brand footer-brand" href="/" data-testid="footer-brand">
        <img src="/assets/logo.png" alt="" width="40" height="40" />
        <span>
          Blankwater<small>ONTRUIMING &amp; HERGEBRUIK</small>
        </span>
      </a>
      <div className="footer-contact">
        <p>
          Meer ruimte. Minder zorgen.
          <br />
          Laarbeek en omgeving.
        </p>
        <a href="tel:+31613767661" data-testid="footer-tel">06 1376 7661</a>
        <a href="mailto:info@blankwaters.nl" data-testid="footer-email">info@blankwaters.nl</a>
        <a href="https://blankwaters.nl/" data-testid="footer-site">blankwaters.nl</a>
        <a
          href="https://wa.me/31613767661"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp"
        >
          WhatsApp ↗
        </a>
      </div>
      <details className="privacy" data-testid="footer-privacy">
        <summary>Privacy &amp; website</summary>
        <p>
          Het formulier zet op jouw apparaat een bericht klaar. Je kiest zelf of je het via e-mail
          of WhatsApp verstuurt. De website slaat je formulierinvoer niet op. Als je contact
          opneemt, ontvangen we je bericht en de gegevens die je meestuurt om je aanvraag te
          bespreken. Voor vragen over je gegevens kun je mailen naar{" "}
          <a href="mailto:info@blankwaters.nl">info@blankwaters.nl</a>. We gebruiken geen
          marketingcookies. Hosting kan technische gegevens verwerken om de website te leveren.
        </p>
      </details>
      <p className="copyright">© {year} Blankwater</p>
      <a className="footer-login" href="/beheer" data-testid="footer-login">
        Inloggen
      </a>
    </motion.footer>
  );
}
